import berthit from 'berthit'

import services from '@/services'

import * as types from './mutations-types'

export const findArticles = async context => {
  const articles = await services.knowledgeBase.filterArticles()

  context.commit(types.CLEAR_ARTICLES)

  context.commit(types.INCLUDE_ARTICLES, articles.slice(0, 7))

  context.commit(types.SET_ARTICLES_HASMORE, articles.length > 7)
}

export const searchArticles = async (context, term) => {
  const response = await services.knowledgeBase.searchArticles(term)

  context.commit(types.CLEAR_ARTICLES)

  context.commit(types.INCLUDE_ARTICLES, response.articles)

  context.commit(types.SET_ARTICLES_SCROLL, response.scroll)

  context.commit(types.SET_ARTICLES_TOTAL, response.total)

  context.commit(
    types.SET_ARTICLES_HASMORE,
    response.total !== response.articles.length
  )
}

export const moreArticles = async context => {
  const scrollId = context.getters.articlesScroll

  if (scrollId) {
    const articles = await services.knowledgeBase.scrollArticles(scrollId)

    context.commit(types.INCLUDE_ARTICLES, articles)

    context.commit(
      types.SET_ARTICLES_HASMORE,
      context.getters.articlesTotal !== context.getters.allArticles.length
    )
  } else {
    const articles = await services.knowledgeBase.filterArticles(
      context.getters.articlesLastDate
    )

    context.commit(types.INCLUDE_ARTICLES, articles.slice(0, 7))

    context.commit(types.SET_ARTICLES_HASMORE, articles.length > 7)
  }
}

export const setKbTyping = (context, payload) =>
  context.commit(types.SET_KB_TYPING, payload)

export const setKbLoader = (context, payload) =>
  context.commit(types.SET_KB_LOADER, payload)

export const setKbSearchResult = (context, payload) =>
  context.commit(types.SET_KB_SEARCH_RESULT, payload)

export const setCurrentArticle = async (context, value) => {
  if (value) {
    const { title, content } = await services.knowledgeBase.recordArticle(value)

    const deniedCSSProps = [
      'width',
      'height',
      'position',
      'top',
      'left',
      'transform',
      'margin'
    ]

    const deniedHTMLTags = ['script', 'style', 'link', 'meta']

    const videoTags = ['iframe', 'video', 'embed']

    let sanitizedContent = content

    if (typeof sanitizedContent === 'string') {
      sanitizedContent = sanitizedContent.replace(
        new RegExp(
          `(style=(["']).*?)(?:[^a-zA-Z\\-])((?:${deniedCSSProps.join(
            '|'
          )}):\\s*[^;]*;?)(.*?\\2)`,
          'gm'
        ),
        '$1$4'
      )

      sanitizedContent = sanitizedContent.replace(
        new RegExp(
          `(?:<(${deniedHTMLTags.join(
            '|'
          )})[^>]*?>.*?<\\/\\1>|<(${deniedHTMLTags.join('|')})[^>]*?\\/?>)`,
          'gm'
        ),
        ''
      )

      sanitizedContent = sanitizedContent.replace(
        new RegExp(`(<(${videoTags.join('|')})[^>]*?>.*?<\\/\\2>)`, 'gm'),
        '<div class="video-fluid-16-9">$1</div>'
      )
    }

    sanitizedContent = berthit(sanitizedContent, { target: '_system' })

    context.commit(types.SET_CURRENT_ARTICLE, {
      title,
      content: sanitizedContent
    })
  } else context.commit(types.SET_CURRENT_ARTICLE, null)
}

export const setIsCurrentArticleLoading = (context, value) =>
  context.commit(types.SET_IS_CURRENT_ARTICLE_LOADING, value)
